import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router';

import {useMovePage} from '../../hooks/useMovePage';
import styles from './styles/mobile-header.module.css';

import MenuModal from './MenuModal';

import {ReactComponent as CloseImg} from '../../assets/common/close.svg';
import {ReactComponent as HamburgerImg} from '../../assets/common/hamburger.svg';
import {ReactComponent as DarvisLogoImg} from '../../assets/logo/darvis-logo.svg';

export default function MobileHeader() {
    const [isOpenMenu, setIsOpenMenu] = useState(false);

    const location = useLocation();

    const movePage = useMovePage();

    const toggleMenu = () => {
        setIsOpenMenu(!isOpenMenu);
    };

    useEffect(() => {
        setIsOpenMenu(false);
    }, [location]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.logo} onClick={() => movePage('/')}>
                    <DarvisLogoImg />
                </div>
                <div onClick={toggleMenu}>
                    {isOpenMenu ? <CloseImg /> : <HamburgerImg />}
                </div>
                {isOpenMenu ? <MenuModal /> : null}
            </div>
        </div>
    );
}
